export default "/fonts/zenloop-regular-webfont.woff2?3f006b963bd133a50fbdb4f0ea255ac7";